import React, { useEffect, useState } from 'react'
import Navbar from "../../components/NavBar/Index"
import Home from "../../components/Home/index"
import { useNavigate, useParams } from 'react-router-dom'
import Dashboard from '../../components/Home/Dashboard'
import apiClient from '../../utils/apiclient'
import OrderRatings from '../../components/Ratings/OrderRatings'
const Index = () => {
    const navigate=useNavigate()
    const [ratings,setRatings]= useState([])
useEffect(() => {
  if (!localStorage.getItem("bentoAdmin")) {
    navigate("/login");
    return;
  }

  fetchRatings();
},[]);

const fetchRatings = async () => {
  try {
    const res = await apiClient.get(`order/rating`);
    setRatings(res.data);
  } catch (e) {
    console.error(e);
  }
};

  return (
    <div className='flex flex-1 flex-col overflow-hidden px-2 md:px-4'>
      <div className="bg-white flex-shrink-0 mt-2 flex justify-center">
        <Dashboard />
      </div>
      <div className='flex-1 flex flex-col min-h-0 mt-2 overflow-hidden'> 
        <OrderRatings data={ratings} />
      </div>
    </div>
  )
}

export default Index